import { COLORS } from '@/theme';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const StyledBadge = styled.div<{ $isActive?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 5.625rem;
  height: 1.5rem;
  border-radius: 1.6rem;
  background: ${({ $isActive }) => ($isActive ? COLORS.GREEN : COLORS.NORMAL_GRAY)};
  color: ${COLORS.WHITE};
`;
